<script setup>
// read json contents of file /Users/craighopkins/Desktop/Patching.applicationDefinitions.json

import { apiQuery } from "@/api/j24api";

import { onMounted, reactive, ref } from "vue";

// data.forEach((app) => {
//   console.log(app.id);
// });
var data = [];
const loading = ref(true);
const lastUpdated = reactive([]);
const noPatches = reactive([]);
const duplicates = reactive([]);

onMounted(async () => {
  let result = await apiQuery("ELA", "patching/patchingVersions", {
    apiAction: "GetAppDefinitions",
  });
  if (result.patchApps.length) {
    data = result.patchApps;
  } else {
    data = [];
  }
  processData(data);
  loading.value = false;
});

function duplicatePatches(date) {
  duplicates.length = 0; // Clear the array before processing new data
  let streams = ["Intel", "AppleSilicon"];
  streams.forEach((stream) => {
    const patches = data.filter((p) => p.stream == stream);
    patches.forEach((patch) => {
      // Find the most recent patch
      var mostRecentPatch = patch.patches.reduce((latest, patch) => {
        if (
          !latest ||
          new Date(patch.releaseDate) > new Date(latest.releaseDate)
        ) {
          return patch;
        }
        return latest;
      }, null);
      if (mostRecentPatch) {
        console.log("Most recent patch:", mostRecentPatch);
        var bundleId = null;
        if (mostRecentPatch.components?.length > 0) {
          console.log("Components:", mostRecentPatch.components);
          bundleId = mostRecentPatch.components[0].criteria.find(
            (c) => c.name === "Application Bundle ID"
          )?.value;
          console.log(mostRecentPatch.components);
        }
        console.log("Bundle ID:", bundleId);
        if (bundleId) {
          const duplicate = duplicates.find((d) => d.bundleId === bundleId);
          if (!duplicate) {
            duplicates.push({
              name: patch.name,

              bundleId: bundleId,
              stream: [stream],
              releaseDate: mostRecentPatch.releaseDate,
              version: mostRecentPatch.version,
            });
          } else {
            // If a duplicate already exists update duplicate adding the new stream
            //duplicate.stream += `, ${stream}`;
            let key = duplicates.findIndex((d) => d.bundleId === bundleId);
            console.log("Key:", key);
            if (key !== -1) {
              console.log(duplicates, key);
              duplicates[key].stream.push(stream);
            }
          }
        }
      }
    });
  });
  var result = [];
  // Filter duplicates to retain only those with multiple Intel or multiple AppleSilicon streams
  duplicates.forEach((duplicate, index) => {
    const intelCount = duplicate.stream.filter((s) => s === "Intel").length;
    const appleSiliconCount = duplicate.stream.filter(
      (s) => s === "AppleSilicon"
    ).length;

    if (intelCount > 1 || appleSiliconCount > 1) {
      result.push(duplicate);
    }
  });
  duplicates.length = 0; // Clear the array before processing new data
  duplicates.push(...result);
}

function processLastUpdated(data) {
  lastUpdated.length = 0; // Clear the array before processing new data
  noPatches.length = 0; // Clear the array before processing new data
  // Find the most when an update was last updated
  data.forEach((item) => {
    var record = {};
    record._id = item._id;
    record.name = item.name;
    record.id = item.id;
    record.stream = item.stream;
    if (!item.patches || item.patches?.length === 0) {
      noPatches.push(record);
      return;
    }
    // Find the most recent patch
    var mostRecentPatch = item.patches.reduce((latest, patch) => {
      if (
        !latest ||
        new Date(patch.releaseDate) > new Date(latest.releaseDate)
      ) {
        return patch;
      }
      return latest;
    }, null);
    record.mostRecentPatch = mostRecentPatch;
    if (!mostRecentPatch) {
      lastUpdated.push(record);
      return;
    }
    record.mostRecentPatchDate = mostRecentPatch.releaseDate;
    record.mostRecentPatchVersion = mostRecentPatch.version;
    lastUpdated.push(record);
  });
}

function processData(data) {
  processLastUpdated(data);
  duplicatePatches(data);
}

const headerLastUpdated = [
  {
    title: "Name",
    value: "name",
    sortable: true,
  },
  {
    title: "Stream",
    value: "stream",
    sortable: true,
  },
  {
    title: "ID",
    value: "id",
    sortable: true,
  },
  {
    title: "Last Updated",
    value: "mostRecentPatchDate",
    sortable: true,
  },
  {
    title: "Version",
    value: "mostRecentPatchVersion",
    sortable: true,
  },
];

const lastUpdatedSort = ref([{ key: "mostRecentPatchDate", order: "asc" }]);
</script>

<template>
  <template v-if="!loading">
    <v-row>
      <v-col cols="12">
        <h1>Last Updated</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          v-model:sort-by="lastUpdatedSort"
          :headers="headerLastUpdated"
          :items="lastUpdated"
        ></v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h1>No Patches in definition</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headerLastUpdated"
          :items="noPatches"
        ></v-data-table>
      </v-col>
      <v-row>
        <v-col cols="12">
          <h1>Duplicates (By Bundle ID)</h1>
        </v-col>
      </v-row>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headerLastUpdated"
          :items="duplicates"
        ></v-data-table>
      </v-col>
    </v-row>
  </template>
  <template v-else>
    <v-row>
      <v-col cols="12">
        <h1>Loading...</h1>
      </v-col>
    </v-row>
  </template>
</template>
